import React from "react"
import { VisuallyHidden } from "@kit/design/visually-hidden"

export function MultiplePrices({
  prices,
  selectPrice,
  activePrice,
  activePriceBorderColor,
  textColor
}) {
  const priceElementStyles = {
    active: {
      margin: "0px 4px",
      minWidth: "126px",
      width: "100%",
      borderColor: activePriceBorderColor
    },
    inactive: {
      margin: "0px 4px",
      minWidth: "126px",
      width: "100%",
      borderColor: "#e3e3e3"
    }
  }

  const priceElementInnerContainerStyles = {
    padding: "12px"
  }

  const MAX_PRICE_DIGITS_FOR_SINGLE_LINE_PRICE = 6
  const multiLinePrice = prices.some(
    price => price.amount.length > MAX_PRICE_DIGITS_FOR_SINGLE_LINE_PRICE
  )

  // Ordered by smallest -> largest  (month > quarter > year)
  const sortedPrices = [...prices].sort(
    (a, b) => a.interval_count - b.interval_count
  )

  const priceWithFrequencyStyles = {
    color: "#718096",
    fontFamily: "inherit",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "24px",
    letterSpacing: "0px",
    textAlign: "left",
    display: multiLinePrice ? "block" : "inline"
  }

  const priceFrequencyStyles = {
    color: "var(--gray-900)",
    fontFamily: "inherit",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "24px",
    letterSpacing: "0px",
    textAlign: "left"
  }

  const frequencyTitle = frequency => {
    if (frequency == "month") {
      return "Monthly"
    } else if (frequency == "quarter") {
      return "Quarterly"
    } else {
      return "Yearly"
    }
  }

  const formatPrice = (amount, currency) => {
    const formattedPrice = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency
    }).format(amount / 100)

    return formattedPrice
  }

  const frequency = price => {
    return price.interval
      ? price.formatted.split("/").slice(-1).toString().trim()
      : null
  }

  return (
    <fieldset className="flex justify-center" style={{ padding: "0" }}>
      <VisuallyHidden>
        <legend>Available prices:</legend>
      </VisuallyHidden>
      {sortedPrices.map(price => (
        <div
          key={price.id}
          className="border border-solid rounded"
          style={
            activePrice === price
              ? priceElementStyles.active
              : priceElementStyles.inactive
          }
        >
          <label htmlFor={price.id} style={{ cursor: "pointer" }}>
            <div style={priceElementInnerContainerStyles}>
              <span
                className="block"
                style={{ ...priceFrequencyStyles, color: textColor }}
              >
                {frequencyTitle(frequency(price))}
              </span>

              <span style={priceWithFrequencyStyles}>
                {formatPrice(price.amount, price.currency)}
              </span>
            </div>
            <input
              id={price.id}
              type="radio"
              checked={activePrice === price}
              onChange={() => selectPrice(price)}
              value={price.id}
              style={{ display: "none" }}
            />
          </label>
        </div>
      ))}
    </fieldset>
  )
}
